export default "__VITE_ASSET__Daq$L1GX__"